import React, {ReactNode} from 'react';

import {MaintenancePage} from '/component/screen/MaintenancePage';

import {useMaintenancePageProvider} from './MaintenancePageProvider.hook';

interface Maintenance {
  startMaintenanceDate?: string;
  endMaintenanceDate?: string;
}

interface MaintenancePageProviderProps {
  children: ReactNode;
  maintenance: Maintenance;
}

export const MaintenancePageProvider = ({
  children = null,
  maintenance = {startMaintenanceDate: '', endMaintenanceDate: ''},
}: MaintenancePageProviderProps) => {
  const {isMaintenance, updateMaintenance} = useMaintenancePageProvider({
    maintenance,
  });

  return isMaintenance ? (
    // @ts-expect-error TS(2322): Type '{ updateMaintenance: () => void; }' is not a... Remove this comment to see the full error message
    <MaintenancePage updateMaintenance={updateMaintenance} />
  ) : (
    children
  );
};

export default MaintenancePageProvider;
